import React from "react"
import { Grid } from "@material-ui/core"
import UserFormElement from "./UserFormElement"
import { UserFormRowPropTypes } from "./CustomFormPropTypes"
import { FORM_ADDABLE_ELEMENTS_TYPES } from "../admin/forms/AdminFormCreationAddableElements"

export default function UserFormRow({ rowElements, onBlur, elementsNumbers }) {
  if (rowElements.length === 1) {
    return (
      <UserFormElement
        element={rowElements[0]}
        elementNumber={elementsNumbers[rowElements[0].id]}
        onBlur={onBlur}
      />
    )
  }

  function elementIsSeparator(element) {
    return element.type === FORM_ADDABLE_ELEMENTS_TYPES.SEPARATOR
  }

  return (
    <Grid direction="row" alignItems="stretch" container>
      {rowElements.map((element) => {
        return (
          <Grid xs={!elementIsSeparator(element)} item key={element.id}>
            <UserFormElement
              isSibling
              element={element}
              onBlur={onBlur}
              elementNumber={elementsNumbers[element.id]}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}

UserFormRow.propTypes = UserFormRowPropTypes.isRequired
